'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Image from 'next/image'
import styles from './styles.module.css'

interface ApproachItem {
	icon: string
	title: string
	description: string
}

const ForWhom: React.FC = () => {
	const approaches: ApproachItem[] = [
		{
			icon: '/images/outstaffing/forwhom_1.svg',
			title: 'Своя команда загружена',
			description: 'Аутстаф-специалисты подключаются на любом этапе — не меняют ваши процессы, просто закрывают нехватку рук.'
		},
		{
			icon: '/images/outstaffing/forwhom_2.svg',
			title: 'Нужны разные роли',
			description: 'Для продукта нужны разные роли, но держать каждого в штате весь год дорого. Бэкенд, фронтенд, дизайнер, тестировщик — мы формируем нужный состав под конкретный этап.'
		},
		{
			icon: '/images/outstaffing/forwhom_3.svg',
			title: 'Сроки уже горят',
			description: 'Поиск затягивается, а сроки уже горят. Специалист из нашего резерва выходит после согласования — пока обычный найм только собирает отклики.'
		}
	]

	return (
		<section className={styles.forWhom}>
			<div className={styles.container}>
				<div className={styles.content}>
					<AnimatedSection animation='slideUp'>
						<div className={styles.subtitle}>Для кого и зачем</div>
						<h2 className={styles.title} dangerouslySetInnerHTML={{ __html: '<span>Аутстаффинг поможет решить</span> вашу задачу, когда:' }} />
					</AnimatedSection>

					<div className={styles.items}>
						{approaches.map((item, index) => (
							<AnimatedSection key={index} animation='slideUp'>
								<div className={styles.item}>
									<div className={styles.itemHeader}>
										<div className={styles.itemSvg}>
											<Image src={item.icon} alt={item.title} width={32} height={32} />
										</div>
										<h3 className={styles.itemTitle}>{item.title}</h3>
									</div>
									<p className={styles.itemDescription}>{item.description}</p>
								</div>
							</AnimatedSection>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

ForWhom.displayName = 'ForWhom'

export default ForWhom
